<!-- @format -->
<template>
	<div v-if="link" class="pcp-mo-layout-component-inner-link-iframe-wrap">
		<iframe
			:id="iframeId"
			ref="refIframe"
			:src="url"
			frameborder="no"
			width="100%"
			height="100%"
			scrolling="auto"
			@load="onLoadIframe"
		/>
	</div>
</template>
<script setup lang="ts">
	import { getEnvUrlByUrl } from '@power/runtime-vue3';
	import { injectCssToIframeDocument, injectCssToDocument } from '@power/utils';
	interface Props {
		link?: string; // 基础路径
	}
	const lastUrl = ref('');
	const props = withDefaults(defineProps<Props>(), {
		link: '',
	});
	const route = useRoute();
	const link = props.link || route.meta.link;
	const url = getEnvUrlByUrl(decodeURIComponent(link));
	lastUrl.value = url;
	const iframeId = computed(() => route.meta.title || url);
	// console.log('setup.iframeId.value', iframeId.value);
	const refIframe = ref(null);

	const onLoadIframe = () => {
		const cssUrl = getEnvUrlByUrl(`power-front-base/frontend/css/commonstyle.css`);

		injectCssToIframeDocument(document, iframeId.value, cssUrl);
		injectCssToDocument(document, cssUrl);
	};

	// watch(
	// 	() => route.meta.link,
	// 	() => {
	// 		const link = route.meta.link;
	// 		const url = decodeURIComponent(link);
	// 		refIframe.value?.setAttribute('src', url);
	// 	},
	// );

	watch(
		() => props.link,
		() => {
			const link = props.link;
			const url = getEnvUrlByUrl(decodeURIComponent(link));
			if (lastUrl.value !== url) {
				lastUrl.value = url;
				refIframe.value?.setAttribute('src', url);
			}
		},
	);
</script>
<style scoped lang="scss">
	.page-inner-link {
		.pcp-mo-layout-component-inner-link-iframe-wrap {
			bottom: 50px;
		}
	}

	.pcp-mo-layout-component-inner-link-iframe-wrap {
		position: absolute;
		top: var(--status-bar-nav-bar-height);
		bottom: 0;
		right: 0;
		left: 0;
	}
</style>
